import { ModalConfig } from './../modals.service';
import {
    Component,
    AfterContentInit,
    Type,
    ChangeDetectorRef,
    ViewChild,
    ViewContainerRef,
    Injector,
} from '@angular/core';
import {
    bounceInOnEnterAnimation,
    bounceOutOnLeaveAnimation,
} from 'angular-animations';
import { ModalOverlayRef } from '../modal-overlay-ref';

@Component({
    selector: 'serviceos-ng-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    animations: [
        bounceInOnEnterAnimation({ duration: 500 }),
        bounceOutOnLeaveAnimation({ duration: 500 }),
    ],
})
export class DialogComponent implements AfterContentInit {
    public visible = false;

    @ViewChild('componentContainer', { read: ViewContainerRef })
    public componentContainer!: ViewContainerRef;

    public config!: ModalConfig;
    public modalRef!: ModalOverlayRef;
    public contentComponentType!: Type<any>;
    public componentRef?: any;

    constructor(private readonly cdr: ChangeDetectorRef) {}

    ngAfterContentInit() {
        this.visible = true;
        setTimeout(() => {
            this.renderComponent();
        }, 10);
    }

    closeAnimation() {
        this.visible = false;
        this.cdr.detectChanges();
    }

    close(): void {
        this.modalRef.close();
    }

    renderComponent() {
        this.componentContainer?.clear();
        this.componentRef = this.componentContainer?.createComponent(
            this.contentComponentType,
            {
                index: 0,
                injector: Injector.create({
                    providers: [
                        { provide: ModalOverlayRef, useValue: this.modalRef },
                    ],
                }),
            }
        );
        this.cdr.detectChanges();
    }
}
